import React from 'react';
import { footerData, navigationItems } from '../data/mock';
import { Mail, Phone, MapPin, ArrowUpRight, MessageCircle } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer
      id="contact"
      className="px-6 py-20 md:pl-24"
    >
      <div className="max-w-5xl mx-auto">
        
        {/* Main CTA Card */}
        <div 
          className="bg-[#1F4E79] border-[3px] border-[#2D2D2D] p-8 md:p-12 text-center"
          style={{ 
            borderRadius: '255px 15px 225px 15px / 15px 225px 15px 255px',
            boxShadow: '6px 6px 0px #2D2D2D'
          }}
        >
          {/* Icon */}
          <div 
            className="inline-flex items-center justify-center w-16 h-16 bg-[#F08A24] 
              border-2 border-[#2D2D2D] mb-6"
            style={{ borderRadius: '15px 225px 15px 255px / 255px 15px 225px 15px' }}
          >
            <MessageCircle className="w-8 h-8 text-white icon-sketch" />
          </div>

          {/* Title */}
          <h2 className="font-marker text-2xl md:text-4xl text-white mb-4">
            {footerData.title}
          </h2>

          {/* Text */}
          <p className="font-architect text-lg md:text-xl text-white/85 mb-8 max-w-xl mx-auto">
            {footerData.text}
          </p>

          {/* CTA Button - mailto link */}
          <a
            href="mailto:contact@ba-inmotion.ma"
            className="bg-[#F08A24] text-white px-8 py-4 
              border-[3px] border-[#2D2D2D] font-patrick text-xl
              inline-flex items-center gap-3
              transition-all hover:-translate-y-1"
            style={{ 
              borderRadius: '255px 15px 225px 15px / 15px 225px 15px 255px',
              boxShadow: '4px 4px 0px #2D2D2D'
            }}
          >
            <Mail className="w-5 h-5" />
            <span>{footerData.cta}</span>
            <ArrowUpRight className="w-5 h-5" />
          </a>
        </div>

        {/* Footer sections */}
        <div className="mt-16 grid grid-cols-2 gap-4 md:gap-12 items-stretch">
          
          {/* Navigation section */}
          <div 
            className="bg-[#FDFBF7]/95 border-[3px] border-[#2D2D2D] p-4 md:p-6 h-full"
            style={{ 
              borderRadius: '255px 15px 225px 15px / 15px 225px 15px 255px',
              boxShadow: '4px 4px 0px #2D2D2D'
            }}
          >
            <h3 className="font-marker text-lg md:text-xl text-[#1F4E79] mb-3 md:mb-4">Navigation</h3>
            <nav className="space-y-2 md:space-y-3">
              {navigationItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="block font-architect text-sm md:text-base text-[#2D2D2D] hover:text-[#F08A24] transition-colors"
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Contact section */}
          <div 
            className="bg-[#FDFBF7]/95 border-[3px] border-[#2D2D2D] p-4 md:p-6 h-full"
            style={{ 
              borderRadius: '15px 225px 15px 255px / 255px 15px 225px 15px',
              boxShadow: '4px 4px 0px #2D2D2D'
            }}
          >
            <h3 className="font-marker text-lg md:text-xl text-[#1F4E79] mb-3 md:mb-4">Contact</h3>
            <div className="space-y-3 md:space-y-4">
              <a 
                href="mailto:contact@ba-inmotion.ma"
                className="flex items-start md:items-center gap-2 md:gap-3 font-architect text-sm md:text-base text-[#2D2D2D] hover:text-[#F08A24] transition-colors"
              >
                <Mail className="w-4 h-4 md:w-5 md:h-5 text-[#F08A24] flex-shrink-0 mt-0.5 md:mt-0" />
                <span className="break-all">contact@ba-inmotion.ma</span>
              </a>
              <a 
                href="tel:+212661118539"
                className="flex items-center gap-2 md:gap-3 font-architect text-sm md:text-base text-[#2D2D2D] hover:text-[#F08A24] transition-colors"
              >
                <Phone className="w-4 h-4 md:w-5 md:h-5 text-[#F08A24] flex-shrink-0" />
                <span>+212 6 61 11 85 39</span>
              </a>
              <div className="flex items-center gap-2 md:gap-3 font-architect text-sm md:text-base text-[#2D2D2D]">
                <MapPin className="w-4 h-4 md:w-5 md:h-5 text-[#F08A24] flex-shrink-0" />
                <span>Casablanca, Maroc</span>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom bar with logo and copyright */}
        <div className="mt-12 pt-8 border-t-2 border-[#2D2D2D]/20">
          <div className="flex flex-col items-center gap-4">
            {/* Logo and name */}
            <div className="flex items-center gap-4">
              <img
                src="https://customer-assets.emergentagent.com/job_b4ea4401-b92b-497f-9584-a787add51601/artifacts/9szg6k9y_logo%20transparant.png"
                alt="BAIM Logo"
                className="w-16 h-auto"
              />
              <span className="font-patrick text-lg text-[#2D2D2D]">
                Business Agility in Motion
              </span>
            </div>

            {/* Copyright */}
            <p className="font-architect text-sm text-[#2D2D2D]/60">
              © 2026 BAIM - Business Agility in Motion. Tous droits réservés.
            </p>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
